const LIVE_BUCKET_INITIAL_STATE = {
	sub_category: [],
};

export default LIVE_BUCKET_INITIAL_STATE;
